/**
 * Stable heading ids for Spotlight Portable Text (match existing markdown article behavior).
 */
export function generateSpotlightSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}
